<div>
    <app-dealer-list></app-dealer-list>
</div>

<div>
    <app-dealer-form></app-dealer-form>
</div>>